import React, { useState } from 'react';
import './addportfolio.css';

const API_URL = process.env.REACT_APP_API_URL;

const AddPortfolio = ({ onClose, id, fetchUser }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            const reader = new FileReader();
            reader.onload = () => {
                setPreviewUrl(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handlePortfolioAdd = async (event) => {
        event.preventDefault();

        // Prevent duplicate submissions
        if (isSubmitting) {
            return;
        }

        if (!selectedFile) {
            setError("Please add an image");
            return;
        }

        const formData = new FormData();
        formData.append('image', selectedFile);
        formData.append('titleinput', event.target.portfoliotitle.value);
        formData.append('linkinput', event.target.portfoliolink.value);

        try {
            setIsSubmitting(true);
            setError('');

            const response = await fetch(`${API_URL}/myprofile/${id}/addportfolio`, {
                method: 'POST',
                body: formData
            });
            
            if (!response.ok) {
                throw new Error('Failed to create portfolio');
            }

            await fetchUser();
            onClose();
        } catch (error) {
            console.error("Error adding portfolio:", error);
            setError('Failed to create portfolio. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <div className="portfolio-popup-container">
            <div className="portfolio-popup">
                <button 
                    className="portfolio-closeBtn" 
                    onClick={onClose}
                    disabled={isSubmitting}
                >
                    <i className="fa-solid fa-x" />
                </button>
                <div className="portfolio-popupcontent">
                    <h2 className="font-normal">Add a Portfolio</h2>
                    <form onSubmit={handlePortfolioAdd}>
                        <div className="mb-4">
                            {previewUrl && (
                                <img 
                                    src={previewUrl} 
                                    alt="Preview" 
                                    className="startportImg" 
                                />
                            )}
                        </div>

                        <div className="mb-4">
                            <span className="mx-4">Image Upload</span>
                            <input 
                                type="file" 
                                onChange={handleFileChange}
                                disabled={isSubmitting}
                                accept="image/*"
                            />
                        </div>

                        {error && (
                            <p className="text-red-500 text-sm mb-4">{error}</p>
                        )}

                        <input 
                            type="text" 
                            className="portfolio-forminput" 
                            name="portfoliotitle" 
                            placeholder="Title" 
                            required 
                            disabled={isSubmitting}
                        />
                        <input 
                            type="text" 
                            className="portfolio-forminput" 
                            name="portfoliolink" 
                            placeholder="Portfolio Link" 
                            required 
                            disabled={isSubmitting}
                        />
                        <button 
                            type="submit" 
                            className="portfolio-forminput"
                            disabled={isSubmitting}
                            style={{ 
                                backgroundColor: isSubmitting ? '#ccc' : '#09CE78',
                                color: 'white',
                                padding: '0.6rem 0',
                                marginTop: '1rem',
                                cursor: isSubmitting ? 'not-allowed' : 'pointer'
                            }}
                        >
                            {isSubmitting ? 'Adding...' : 'Add'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddPortfolio;